import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import {
  LifeBuoyIcon,
  PackageIcon,
  RadarIcon,
  SettingsIcon,
  ShoppingBasketIcon,
} from '@/shared/ui/icons';
import { cn } from '@/shared/utils/cn';

const ITEMS = [
  { to: '/parcels', labelKey: 'nav:parcels', icon: PackageIcon, end: true },
  { to: '/packages', labelKey: 'nav:packages', icon: ShoppingBasketIcon, end: false },
  { to: '/track', labelKey: 'nav:track', icon: RadarIcon, end: false },
  { to: '/support', labelKey: 'nav:support', icon: LifeBuoyIcon, end: false },
  { to: '/settings', labelKey: 'nav:settings', icon: SettingsIcon, end: false },
] as const;

export const BottomNav = () => {
  const { t } = useTranslation();
  return (
  <nav
    aria-label={t('nav:main')}
    className="fixed inset-x-0 bottom-0 z-30 border-t border-slate-200 bg-white safe-bottom md:hidden"
  >
    <ul className="grid grid-cols-5">
      {ITEMS.map(({ to, labelKey, icon: Icon, end }) => (
        <li key={to}>
          <NavLink
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                'flex cursor-pointer flex-col items-center justify-center gap-1 px-2 py-2.5 text-xs font-medium transition-colors',
                isActive ? 'text-brand-600' : 'text-ink-muted hover:text-ink-soft',
              )
            }
          >
            <Icon className="h-5 w-5" aria-hidden />
            <span>{t(labelKey)}</span>
          </NavLink>
        </li>
      ))}
    </ul>
  </nav>
  );
};
